<div class="w-full mx-auto h-screen p-5">
    <h1 class="text-2xl font-bold mb-4">{{ isEditing ? 'Editar' : 'Crear Nuevo' }} Tipo de Comisión</h1>

    <form [formGroup]="feeTypeForm" (ngSubmit)="onSubmit()">
        
        <!-- Nombre del Tipo de Comisión -->
        <div class="mb-4">
            <label for="name" class="block text-gray-700 font-bold mb-2" appRequiredLabel>
                Nombre del Tipo de Comisión
            </label>
            <input
                type="text"
                id="name"
                formControlName="name"
                class="w-full px-3 py-2 border rounded-md"
                [ngClass]="{'border-red-500': hasError('name', 'required') || hasError('name', 'minlength') || hasError('name', 'maxlength')}"
                placeholder="Ej: Comisión por transferencia, Fee administrativo, Descuento por volumen"
            >
            <div class="text-red-500 text-sm mt-1" *ngIf="hasError('name', 'required')">
                El nombre del tipo de comisión es obligatorio
            </div>
            <div class="text-red-500 text-sm mt-1" *ngIf="hasError('name', 'minlength')">
                El nombre debe tener al menos 3 caracteres
            </div>
            <div class="text-red-500 text-sm mt-1" *ngIf="hasError('name', 'maxlength')">
                El nombre no puede exceder 100 caracteres
            </div>
        </div>

        <!-- Descripción -->
        <div class="mb-4">
            <label for="description" class="block text-gray-700 font-bold mb-2">
                Descripción (Opcional)
            </label>
            <textarea
                id="description"
                formControlName="description"
                rows="3"
                class="w-full px-3 py-2 border rounded-md"
                [ngClass]="{'border-red-500': hasError('description', 'maxlength')}"
                placeholder="Describe el tipo de comisión y cuándo aplica..."
            ></textarea>
            <div class="text-red-500 text-sm mt-1" *ngIf="hasError('description', 'maxlength')">
                La descripción no puede exceder 250 caracteres
            </div>
            <div class="text-gray-500 text-xs mt-1">
                {{ (feeTypeForm.get('description')?.value || '').length }}/250 caracteres
            </div>
        </div>

        <!-- Información adicional -->
        <div class="mb-6 p-4 bg-blue-50 border-l-4 border-blue-400 rounded">
            <div class="flex">
                <div class="flex-shrink-0">
                    <svg class="h-5 w-5 text-blue-400" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/>
                    </svg>
                </div>
                <div class="ml-3">
                    <h3 class="text-sm font-medium text-blue-800">Información sobre Tipos de Comisión</h3>
                    <div class="mt-2 text-sm text-blue-700">
                        <p>Los tipos de comisión permiten categorizar y gestionar diferentes conceptos de cobros adicionales en el sistema financiero.</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Botones -->
        <div class="flex justify-end mt-4 gap-4">
            <button
                type="button"
                (click)="router.navigate(['/config/fee-types'])"
                class="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition"
            >
                Cancelar
            </button>
            <button
                type="submit"
                [disabled]="feeTypeForm.invalid || submitting"
                class="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition disabled:opacity-50 disabled:cursor-not-allowed"
            >
                {{ isEditing ? 'Actualizar' : 'Guardar' }}
            </button>
        </div>
    </form>
</div>
